export const formatPhoneNumber = (value) => {
  // Eğer değer +90'dan kısa veya boşsa, +90 döndür
  if (!value || value.length < 3) {
    return "+90";
  }

  // +90'ı her zaman koru
  if (!value.startsWith("+90")) {
    // Eğer +90 ile başlamıyorsa, sadece rakamları al ve +90 ekle
    const numbers = value.replace(/\D/g, "");

    // Eğer 0 ile başlıyorsa, 0'ı kaldır (çünkü +90 zaten var)
    let cleanNumbers = numbers;
    if (numbers.startsWith("0")) {
      cleanNumbers = numbers.substring(1);
    }

    // Maksimum 10 rakam
    const limitedDigits = cleanNumbers.substring(0, 10);

    // Formatla
    if (limitedDigits.length === 0) {
      return "+90";
    } else if (limitedDigits.length <= 3) {
      return `+90 (${limitedDigits}`;
    } else if (limitedDigits.length <= 6) {
      return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
        3
      )}`;
    } else if (limitedDigits.length <= 8) {
      return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
        3,
        6
      )} ${limitedDigits.substring(6)}`;
    } else {
      return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
        3,
        6
      )} ${limitedDigits.substring(6, 8)} ${limitedDigits.substring(8)}`;
    }
  }

  // +90 ile başlıyorsa, sadece rakamları al ve formatla
  const afterPrefix = value.substring(3);
  const numbers = afterPrefix.replace(/\D/g, "");

  // Maksimum 10 rakam
  const limitedDigits = numbers.substring(0, 10);

  // Formatla: +90 (XXX) XXX XX XX
  if (limitedDigits.length === 0) {
    return "+90";
  } else if (limitedDigits.length <= 3) {
    return `+90 (${limitedDigits}`;
  } else if (limitedDigits.length <= 6) {
    return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
      3
    )}`;
  } else if (limitedDigits.length <= 8) {
    return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
      3,
      6
    )} ${limitedDigits.substring(6)}`;
  } else {
    return `+90 (${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
      3,
      6
    )} ${limitedDigits.substring(6, 8)} ${limitedDigits.substring(8)}`;
  }
};

export const unformatPhoneNumber = (value) => {
  return `+${value.replace(/\D/g, "")}`;
};
